import React from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarFooter,
  SidebarContent,
} from 'react-pro-sidebar';
import { FaHome, FaCog } from 'react-icons/fa';
import { BsBriefcaseFill } from 'react-icons/bs'
import bgImage from './../../../images/bg1.jpg'

export class Aside extends React.Component{

    handleToggleSidebar(e){
        this.props.mapState("ASIDE_TOGGLER", !this.props.asideToggled)
    }

    logout = () => {       
        this.props.history.replace("/#/Admin/")  
        sessionStorage.clear()
    }

    render(){
        return (
            <ProSidebar
                rtl={false}
                image={this.props.asideBgImage ? bgImage : ""}
                collapsed={this.props.asideColapsed}
                toggled={this.props.asideToggled}
                breakPoint="md"
                onToggle={(e) => this.handleToggleSidebar(e)}        
                className="pro-sidebar-color"
            >
                <SidebarContent>
                    <Menu iconShape="circle">
                        <MenuItem
                            icon={<FaHome size={24}/>}
                            //suffix={<span className="badge red">Novo</span>}
                            active={true}
                        >
                            <Link to="/Admin/dashboard" onClick={(e) => this.handleToggleSidebar(e)}>Opći podaci</Link>
                        </MenuItem>  

                        <MenuItem icon={<BsBriefcaseFill size={24}/>} >
                            <Link to="/Admin/client" onClick={(e) => this.handleToggleSidebar(e)}>Klijenti</Link>
                        </MenuItem>

                        <MenuItem icon={<FaCog size={24}/>}> 
                            <Link to="/Admin/settings" onClick={(e) => this.handleToggleSidebar(e)}>Postavke</Link>
                        </MenuItem>


                    </Menu>
                </SidebarContent>

                <SidebarFooter style={{ textAlign: 'center' }}>
            
                </SidebarFooter>
            </ProSidebar>
        );
    };
}


const mapStateToProps = state => {
  return {
      userLoggedIn: state.user.userLoggedIn,
      asideBgImage: state.user.asideBg,
      asideColapsed: state.user.asideColapsed,
      asideToggled: state.user.asideToggled
  };
};

const mapDispatchToProps = dispatch => {
  return {
    mapState: (type, data) => dispatch({ type: type, data: data})
  };
};



export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Aside);

